import { zonedTimeToUtc } from 'date-fns-tz'
import React, { ReactElement } from 'react'

import date from '@lib/date'
import { useTranslation } from '@lib/i18n'

export interface DurationProps {
  departureTime: string
  arrivalTime: string
  departureTimezone?: string
  arrivalTimezone?: string
  highlightNumbers?: boolean
}

const Duration = (props: DurationProps): ReactElement => {
  const { departureTime, departureTimezone, arrivalTime, arrivalTimezone, highlightNumbers } = props
  const { t } = useTranslation()
  const departure = zonedTimeToUtc(date.parse(departureTime, 'UTC'), departureTimezone ?? '')
  const arrival = zonedTimeToUtc(date.parse(arrivalTime, 'UTC'), arrivalTimezone ?? '')

  return (
    <span className="row gap-0.5">
      {Object.entries(date.durationToObject(departure, arrival, ['hours', 'minutes'])).map(([key, value]) => {
        const replaced = key.replace('hours', t('ui.hoursShort')).replace('minutes', t('ui.minutesShort'))

        return (
          <span key={key}>
            {highlightNumbers ? <b>{value}</b> : value}
            {replaced}
          </span>
        )
      })}
    </span>
  )
}

export default Duration
